<template>
    <div class="item">
        <van-panel
                :title="value.asset_name"
                :desc="value.asset_type"
                :status="value.Status">
            <div>
                <!--<van-cell
                        v-for="it in items"
                        :key="it.name"
                        :title="it.name"
                        :value="it.value"
                        :border="false"
                        size="small" />-->
                <van-cell
                   :title="$t('message.assetNum')"
                   :value="value.asset_num"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.serial')"
                   :value="value.serial"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.heldby')"
                   :value="value.chinese_name"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.storage')"
                   :value="value.storage"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.dept')"
                   :value="value.dept"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.stockPerson')"
                   :value="value.stock_person"
                   v-if="type == 'stocked'"
                   :border="false"
                   size="small" />
                <van-cell
                   :title="$t('message.stockTime')"
                   :value="formatDate(value.stock_time)"
                   v-if="type == 'stocked'"
                   :border="false"
                   size="small" /> 
                   <van-cell
                   :title="$t('message.signTime')"
                   :value="value.sign_time"
                   :border="false"
                   size="small" />   
                   <van-cell
                   :title="$t('message.signStatus')"
                   :value="value.sign_status"
                   :border="false"
                   size="small" />
                   <van-cell
                   :title="$t('message.signPeople')"
                   :value="value.sign_people"
                   :border="false"
                   size="small" />         
<!--                <van-cell-->
<!--                   :title="$t('message.location')"-->
<!--                   :value="value.location"-->
<!--                   :border="false"-->
<!--                   size="small" />-->
            </div>
            <div slot="footer" class="item_footer">
                <van-button
                        v-if="value.stock_status == '待盘点'"
                        type="primary"
                        size="small"
                        round
                        @click="gotoStock">{{ $t('message.stock') }}
                </van-button>
                <van-button
                        v-if="value.stock_status == '已盘点' && type != 'stocked'"
                        type="primary"
                        size="small"
                        disabled
                        round>{{ $t('message.stocked') }}
                </van-button>
                <van-button
                        type="primary"
                        size="small"
                        round
                        class="stock-btn"
                        @click="showDetails = true">{{ $t('message.details') }} 
                </van-button>
            </div>
        </van-panel>

        <!-- 资产详情 -->
        <van-popup v-model="showDetails" @close="closeDetails" position="right" class="detail-container" lock-scroll>
            <van-cell :title="$t('message.assetDetails')" title-class="detail-title" size="large"/>

            <van-cell
                :title="$t('message.assetNum')"
                :value="value.asset_num"
                :border="false"
                class="detail-item"
                size="small" />
            <van-cell
                :title="$t('message.serial')"
                :value="value.serial"
                :border="false"
                class="detail-item"
                size="small" />
            <van-cell
                :title="$t('message.heldby')"
                :value="value.chinese_name"
                :border="false"
                class="detail-item"
                size="small" />
            <van-cell
                :title="$t('message.storage')"
                :value="value.storage"
                :border="false"
                class="detail-item"
                size="small" />
            <van-cell
                :title="$t('message.dept')"
                :value="value.dept"
                :border="false"
                class="detail-item"
                size="small" />
            <van-cell
                title="联系电话"
                :value="value.heldby"
                :border="false"
                class="detail-item"
                size="small" />    
            <!--<van-cell
                    v-for="de in details"
                    :key="de.name"
                    :title="de.name"
                    :value="de.value"
                    class="detail-item"
                    :border="false"/>-->
<!-- 
            <van-cell
                    v-for="(v, n) in value"
                    :key="n"
                    :title="n"
                    :value="v"
                    class="detail-item"
                    :border="false"/> -->

<!--            <div class="detail-close"><van-icon name="clear" @click="closeDetails" class="detail-close-btn"/></div>-->

        </van-popup>

    </div>
</template>
<script>
import { Panel, CellGroup, Cell, Button, Popup, Icon, Toast } from 'vant';
import dayjs from 'dayjs';
export default {
    name:"ListItem",
    components:{
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [Icon.name]: Icon,
        Toast
    },
    props: {
        value: Object,
        type: String
    },
    data(){
        return{
            showDetails: false
        }
    },
    methods:{
        gotoStock() {
            this.$router.push({
                name: 'stock',
                query: {id: this.value.id}
            })
        },
        closeDetails() {
            this.showDetails = false
        },
        formatDate(date) {
            if(date) {
                return dayjs(date).add(8, 'hour').format('YYYY-MM-DD HH:mm')
            }
            return ''
        }
    }
}
</script>
<style lang="less" scoped>
    .item {
        margin: 8px 15px;
        .item_footer {
            text-align: right;
            button {
                width: 60px;
                margin-left: 10px;
            }
        }
        .detail-container {
            height: 70vh;
            width: 75%;
        }
        .detail-close {
            text-align: center;
            font-size: 35px;
            position: fixed;
            bottom: 0;
        }
        .detail-close-btn {
            font-size: 35px;
            position: fixed;
            bottom: 30px;
        }
    }

</style>
